export const EMPLOYEE_ASSETS = 'EMPLOYEE_ASSETS';
